import FetchHelper from '../../helpers/fetch_helper';
import LocationHelper from '../../helpers/location_helper';
import React, { useEffect, useState } from 'react';

const SignInPerson = (props) => {
  const [kbaFailureCalled, setKbaFailureCalled] = useState(false);
  const [displayText, setDisplayText] = useState(
    'Please wait as we redirect you to your loan documents for signature.'
  );
  let { envelopeId, signerName, token, signerRole } = LocationHelper.searchAsObj();
  useEffect(() => {
    if (!kbaFailureCalled) {
      setKbaFailureCalled(true);
      FetchHelper.fetchJson(
        `document-envelopes/${token}/signer-view?envelopeId=${envelopeId}&signerName=${signerName}&signerRole=${signerRole}`,
        {
          method: 'get',
        }
      ).then(
        ({ results }) => {
          window.location.href = results[0];
        },
        (err) => {
          setDisplayText(err?.body?.messages?.[0] || 'We could not complete your request at this time.');
        }
      );
    }
  }, [envelopeId, kbaFailureCalled, signerName, token, signerRole]);
  // )?.results?.[0];
  return (
    <div className="card-page">
      <div className="card secondary-page smaller">
        <h1 className="title blue" id="qa-kba-failure-redirect">
          {displayText}
        </h1>
      </div>
    </div>
  );
};

export default SignInPerson;
